import { toast } from 'sonner';

// Renders an on-page QR <svg> (by element id) onto a labelled poster canvas and downloads it as PNG.
export function downloadQR(svgId, filename) {
  const svg = document.getElementById(svgId);
  if (!svg) return;
  const canvas = document.createElement('canvas');
  canvas.width = 400; canvas.height = 480;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, 400, 480);
  const svgData = new XMLSerializer().serializeToString(svg);
  const img = new Image();
  img.onload = () => {
    ctx.drawImage(img, 60, 20, 280, 280);
    ctx.fillStyle = '#0A0A0A'; ctx.font = 'bold 16px Oswald, sans-serif'; ctx.textAlign = 'center';
    const label = svg.getAttribute('data-label') || '';
    const sub = svg.getAttribute('data-sublabel') || '';
    ctx.fillText(label, 200, 330);
    ctx.font = '12px sans-serif'; ctx.fillStyle = '#737373';
    if (sub) ctx.fillText(sub, 200, 355);
    ctx.font = '10px sans-serif'; ctx.fillStyle = '#AAAAAA';
    ctx.fillText('Powered by AgriBooks Sports', 200, 460);
    const a = document.createElement('a');
    a.download = filename; a.href = canvas.toDataURL('image/png'); a.click();
    toast.success('QR downloaded');
  };
  img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
}
